import script from "./EditAnnouncementInputWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAnnouncementInputWrapper.vue?vue&type=script&setup=true&lang=js"

import "./EditAnnouncementInputWrapper.vue?vue&type=style&index=0&id=a59838b0&lang=scss"

export default script